import React, {Component} from 'react'

var Loader                  = require('react-loader');
var ExperienceStoreJson     = require('../../build/contracts/ExperienceStore.json');
var ExperienceStoreAddr     = ExperienceStoreJson.networks["4"].address;

class AddExperience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      credential: {},
      savingCredential: false,
    };
    this.props.web3.eth.getTransactionReceiptMined     = require('./transactionReceipt')
  }

  componentWillMount() {

  }

  addExperience() {
    // console.log(this.state.credential.fromyear)
    // var x = Number("123")
    // if(Number.isInteger(x)){
    //   console.log("yes",x)
    // }
    // else{
    //   console.log("false")
    // }
    this.setState({savingCredential: true});
    let credential      = this.state.credential;
    let This            = this;
    let Props           = this.props;
    let SetState        = this;
    let sender          = this.props.web3.eth.accounts[0];
    let employeeAddress = credential.employeeAddress.trim();
    let experience      = Number(credential.experience);
    let skill           = credential.skill.trim();

    if(Number.isInteger(experience)){
      this.props.experienceStoreContractInstance.amountOfTokensForPosting({gas: 500000,gasPrice: 1200000000}).then((tokens)=>{
        let tokenRequired   = tokens/1000000000000000000;
        this.props.echoLinkContractInstance.allowance(sender,ExperienceStoreAddr,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
          console.log("result:",result/1000000000000000000);
          let availableTokens   = result/1000000000000000000;
          if(availableTokens >= tokenRequired){
            Props.experienceStoreContractInstance.addExperienceToEmployee(employeeAddress,experience,skill,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{

              Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("posting added successfully");
                  SetState.setState({savingCredential: false});
                  // let details = log.args._details;
                  Props.addNotification(`Data saved successfully !`,"success");
                  SetState.setState({credential: {}});
                  Props.onSubmit(result1.tx);
                }
              })
            })
          }
          else if(availableTokens === 0){
            Props.echoLinkContractInstance.approve(ExperienceStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("approved successfully");
                  Props.experienceStoreContractInstance.addExperienceToEmployee(employeeAddress,experience,skill,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                     Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({savingCredential: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("posting added successfully");
                        SetState.setState({savingCredential: false});
                        // let details = log.args._details;
                        Props.addNotification(`Data saved successfully !`,"success");
                        SetState.setState({credential: {}});
                        Props.onSubmit(result1.tx);
                      }
                    })
                  })
                }
              })
            })
          }
          else{
            Props.echoLinkContractInstance.approve(ExperienceStoreAddr,0,{gas: 500000,gasPrice: 1200000000}).then((result)=>{
              Props.web3.eth.getTransactionReceiptMined(result.tx,10,function(txHash){
                if(txHash.txStatus === 0){
                  This.setState({savingCredential: false});
                  Props.addNotification(`Transaction Exection Failed!`,"error");
                }
                if(txHash.txStatus === 1){
                  console.log("first Approve success");
                  Props.echoLinkContractInstance.approve(ExperienceStoreAddr,tokens,{gas: 500000,gasPrice: 1200000000}).then((results)=>{
                    Props.web3.eth.getTransactionReceiptMined(results.tx,10,function(txHash){
                      if(txHash.txStatus === 0){
                        This.setState({savingCredential: false});
                        Props.addNotification(`Transaction Exection Failed!`,"error");
                      }
                      if(txHash.txStatus === 1){
                        console.log("approved successfully");
                        Props.experienceStoreContractInstance.addExperienceToEmployee(employeeAddress,experience,skill,{gas: 500000,gasPrice: 1200000000}).then((result1)=>{
                          Props.web3.eth.getTransactionReceiptMined(result1.tx,10,function(txHash){
                            if(txHash.txStatus === 0){
                              This.setState({savingCredential: false});
                              Props.addNotification(`Transaction Exection Failed!`,"error");
                            }
                            if(txHash.txStatus === 1){
                              console.log("posting added successfully");
                              SetState.setState({savingCredential: false});
                        
                              // let details = log.args._details;
                              Props.addNotification(`Data saved successfully !`,"success");
                              SetState.setState({credential: {}});
                              Props.onSubmit(result1.tx);
                            }
                          })
                        })
                      }
                    })
                  })
                }
              })
            })

          }
        })
      })
    }
    else{
      this.setState({savingCredential: false});
      Props.addNotification(`Experience should be integer`,"error");
    }

    // this.props.credentialsStoreContractInstance.save(issuer, recipient, status, imageHash, {gas: 500000}).then((result) => {
    //    if(result.receipt.status !== "0x1"){ // can be used after byzantium to check status
    //      throw new Error("Transaction failed");
    //   } 

    //   this.setState({savingCredential: false});
    //   console.log('Data saved successfully, Tx:', result.tx);
    //   let log = result.logs[0];
    //   let credentialId = log.args._credentialId.toNumber();
    //   this.props.addNotification(`Data saved successfully ! Credential ID: ${credentialId}`, "success");
    //   this.setState({credential: {}});
    //   this.props.onSubmit(result.tx);
    // }).catch((err) => {
    //   this.setState({savingCredential: false});
    //   this.props.addNotification(err.message, "error");
    // });
  }

  updateInputValue(e, field) {
    let credential = this.state.credential;
    credential[field] = e.target.value;
    this.setState({credential});
    // if(document.getElementById('yes').checked) {
    //   console.log("yes")
    //   //Male radio button is checked
    // }else if(document.getElementById('no').checked) {
    //   console.log("no")
    //   //Female radio button is checked
    // }
  }

  validForm() {
    if (!this.props.experienceStoreContractInstance) {
      return false;
    }

    let credential = this.state.credential;
    return credential.employeeAddress && credential.employeeAddress.trim() &&
      credential.experience &&
      credential.skill && credential.skill.trim();
  }

  render() {
    return (
      <div className="AddExperience">

        <div className="pure-u-24-24"></div>

        <form className="pure-form" onSubmit={(e) => event.preventDefault()}>
          <fieldset className="pure-group">
            <div className="pure-u-4-24">
              <span><b>Employee Address: </b></span>
            </div>
            <div className="pure-u-20-24">
              <input type="text" className="pure-input-1-2" placeholder="Employee Address"
                     value={this.state.credential.employeeAddress} onChange={e => this.updateInputValue(e, 'employeeAddress')}/>
            </div>
            <div className="pure-u-24-24"></div>
            <div className="pure-u-4-24">
              <span><b>Employee Experience: </b></span>
            </div>
            <div className="pure-u-4-24">
              <input type="number" className="pure-input-1-16" placeholder="Years"
                     value={this.state.credential.experience} onChange={e => this.updateInputValue(e, 'experience')}/>
            </div>
            <div className="pure-u-24-24"></div>
            <div className="pure-u-4-24">
              <span><b>Experience in: </b></span>
            </div>
            <div className="pure-u-20-24">
              <input type="text" className="pure-input-1-2" placeholder="Skill : Java,MySql,etc."
                     value={this.state.credential.skill} onChange={e => this.updateInputValue(e, 'skill')}/>
            </div>
          </fieldset>


          <Loader loaded={!this.state.savingCredential}>
            <div className="pure-u-4-24"></div>
            <button type="button" className="pure-button pure-input-1-2 button-success"
                    disabled={!this.validForm() || this.state.savingCredential}
                    onClick={() => this.addExperience()}>Save
            </button>
          </Loader>
        </form>
      </div>
    );
  }
}

export default AddExperience;



// WEBPACK FOOTER //
// ./src/components/addExperience.js